import React from 'react';
import DataTable from 'react-data-table-component';
import { useNavigate } from 'react-router-dom';
import { IconEdit, IconTrash, IconZoomIn, IconEye } from '@tabler/icons-react';
import { useNavigateWithSlugHook, } from "../../../../src/config/routes/guards/slug";

const DatatableRiskDivisions = (props) => {
  // console.log(props);
  const navigate = useNavigateWithSlugHook();
  const handleChangePage = (path) => {
    navigate(path);
  };

  const columns = [
    {
      name: 'Aksi',
      minWidth: '200px', // Set a minimum width for horizontal scroll
      cell: (row) => (
        <>
          <button
            className="btn btn-sm btn-outline-warning"
            type="button"
            title="Edit Divisi"
            onClick={() => props.handleEditDivision(row)}
          >
            <IconEdit stroke={2} />
          </button>
          {/* <button
            className="btn btn-sm btn-outline-danger"
            type="button"
            title="Hapus Divisi"
            onClick={() => props.handleHapusDivision(row.id)}
          >
            <IconTrash stroke={2} />
          </button> */}
        </>
      ),
    },
    {
      name: 'Unit Kerja',
      minWidth: '300px',
      selector: (row) => row.namaDivision,
    },
    {
      name: 'Tanggal Dibuat',
      minWidth: '250px', // Set a minimum width for horizontal scroll
      cell: (row) => (
        <>
          <div style={{ whiteSpace: 'normal', wordWrap: 'break-word' }}>
            {row.createdAt}
          </div>
        </>
      ),
    },
    {
      name: 'Tanggal Diperbarui',
      minWidth: '250px', // Set a minimum width for horizontal scroll
      cell: (row) => (
        <>
          <div style={{ whiteSpace: 'normal', wordWrap: 'break-word' }}>
            {row.updatedAt}
          </div>
        </>
      ),
    },
  ];

  return (
    <>
      <h5 className="card-title">Daftar Unit Kerja</h5>
      <DataTable
        columns={columns}
        data={props.listDivisions}
        pagination
        fixedHeader
        highlightOnHover
        subHeader
        subHeaderComponent={
          <input
            type="text"
            placeholder="Cari Nama Unit Kerja"
            className="w-50 form-control m-3"
            values={props.search}
            onChange={(e) => props.handleChangeSearch(e.target.value)}
          />
        }
        subHeaderAlign="center"
      />
    </>
  );
};

export default DatatableRiskDivisions;
